import React from 'react'
import { Link } from '@material-ui/core'

function BulkActionsHtml(props) {
  const styles = {
    actionIconStyle: {
      display: 'flex',
      margin: '5px',
      padding: '8px 17px',
      backgroundColor: '#c8c5c5',
      borderRadius: '3px',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'black',
    },
  }
  const {
    handleDeleteList,
    onSearchStatus,
    editDynamicListId,
    item,
    handleApppoveList,
    selectedstatusType,
    ApproveOptionBoolean,
    EDitOptionPermission,
    DeleteOptionPermission,
  } = props
  return (
    <td className=' h-100 d-flex justify-content-center align-items-center'>
      {/* <Link to={`/dynamic-lists/${item.id}`}>{item.id}</Link> */}
      {DeleteOptionPermission && <div
        className='col-md-3 cursor-pointer'
        data-toggle='tooltip'
        title={'Delete List'}
        style={styles.actionIconStyle}
        onClick={() => {
          handleDeleteList(item)
        }}
      >
        <i className='fa fa-trash ' />
      </div>}
      {ApproveOptionBoolean && selectedstatusType === 'draft' ? (
        <>
          {onSearchStatus ? null : (
            <div
              className='col-md-3 cursor-pointer'
              data-toggle='tooltip'
              title={'Approve List'}
              style={styles.actionIconStyle}
              onClick={() => {
                handleApppoveList(item)
              }}
            >
              <i className='fas fa-upload'></i>
            </div>
          )}
        </>
      ) : null}
      {EDitOptionPermission && <Link target='_blank' href={`/createDynamicList?${editDynamicListId}`}>
        <div
          className='col-md-3 cursor-pointer'
          data-toggle='tooltip'
          title={'Edit List'}
          style={styles.actionIconStyle}
        >
          <i className='fa fa-edit ' />
        </div>
      </Link>}
    </td>
  )
}

export default BulkActionsHtml
